import { capitalizeFirstLetter } from "~/helpers/jsutil";

export const NAV_LINK_KINDS = Object.freeze({
  fooldal: { routeName: "indexPage", params: [] },
  szakemberek_hub: { routeName: "professionPage", params: ["profession"] },
  szakemberek_city: {
    routeName: "professionals",
    params: ["profession", "city"],
  },
  arak: { routeName: "prices", params: ["professionTask"] },
});

export const PAGE_TYPE_BY_ROUTE_NAME = Object.freeze({
  professionPage: "szakemberek_hub",
  professionals: "szakemberek_city",
  prices: "arak",
});

export const HEADER_MENU_LIMIT = 15;
export const PRICES_MENU_LIMIT = 15;
export const FOOTER_ITEM_COUNT = 6;

const SEO_NAME_PATTERN = /^[a-z0-9-]+$/;

export function isValidSeoName(value) {
  return typeof value === "string" && SEO_NAME_PATTERN.test(value);
}

export function getRouteBaseName(routeName) {
  return (routeName ?? "").split("___")[0];
}

export function getPageType(routeName) {
  return PAGE_TYPE_BY_ROUTE_NAME[getRouteBaseName(routeName)] ?? null;
}

export function buildNavLinkRoute(item) {
  const kind = NAV_LINK_KINDS[item?.kind];
  if (!kind || !item.anchor) {
    return null;
  }

  const params = {};
  for (const param of kind.params) {
    if (!isValidSeoName(item[param])) {
      return null;
    }
    params[param] = item[param];
  }

  return { name: kind.routeName, params };
}

export function navLinkId(prefix, professionSeoName, item) {
  const kind = NAV_LINK_KINDS[item.kind];
  const lastParam = kind.params[kind.params.length - 1];
  return [prefix, professionSeoName, item.kind, lastParam && item[lastParam]]
    .filter(Boolean)
    .join("-");
}

export function normalizePath(path) {
  return (path ?? "").replace(/\/+$/, "") || "/";
}

export function resolveNavLinks(
  items,
  { localePath, currentPath, idPrefix, professionSeoName }
) {
  const current = normalizePath(currentPath);
  const seen = new Set();

  return (items ?? []).reduce((links, item) => {
    const route = buildNavLinkRoute(item);
    if (!route) {
      return links;
    }

    const to = localePath(route);
    const normalized = normalizePath(to);
    if (!to || normalized === current || seen.has(normalized)) {
      return links;
    }

    seen.add(normalized);
    links.push({
      id: navLinkId(idPrefix, professionSeoName, item),
      text: capitalizeFirstLetter(item.anchor),
      to,
    });
    return links;
  }, []);
}

// 32-bit FNV-1a
export function hashString(value) {
  let hash = 0x811c9dc5;
  for (let i = 0; i < value.length; i++) {
    hash ^= value.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193);
  }
  return hash >>> 0;
}

export function pickRotation(links, count, seed) {
  return links
    .map((link) => ({ link, score: hashString(`${seed}|${link.to}`) }))
    .sort((a, b) => a.score - b.score)
    .slice(0, count)
    .map(({ link }) => link);
}

export function monthKey(date = new Date()) {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Europe/Budapest",
    year: "numeric",
    month: "2-digit",
  }).formatToParts(date);
  const part = (type) => parts.find((p) => p.type === type).value;
  return `${part("year")}-${part("month")}`;
}
